<template>
  <div
    class="post-comment__container"
    :class="[replyDepthClass]"
  >
    <div class="post-comment__title">
      {{ type }}: User {{ comment.user }} says
    </div>
    <div class="post-comment__text">
      <span>{{ comment.message }}</span>
      <span
        v-if="comment.messageLine2"
        class="block mt-4"
      >{{ comment.messageLine2 }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NewsForumContentPostComment',

  props: {
    comment: {
      type: Object,
      default: () => ({}),
    },
  },

  computed: {
    type() {
      return this.comment.replyDepth ? 'Reply' : 'Comment'
    },

    replyDepthClass() {
      const classes = {
        1: 'replydepth-1',
        2: 'replydepth-2',
        3: 'replydepth-3',
        4: 'replydepth-4',
        5: 'replydepth-5',
        6: 'replydepth-6',
        7: 'replydepth-7',
      }
      return classes[this.comment.replyDepth]
    },
  },
}
</script>

<style lang="postcss" scoped>
.post-comment {
  &__container {
    font-family: 'proxima-nova';
    font-size: 20px;
    @apply bg-blue-darkest py-4 px-8 border border-blue;

    &.replydepth {
      &-1 {
        padding-left: 64px !important;
      }

      &-2 {
        padding-left: 96px !important;
      }

      &-3 {
        padding-left: 128px !important;
      }

      &-4 {
        padding-left: 160px !important;
      }

      &-5 {
        padding-left: 192px !important;
      }

      &-6 {
        padding-left: 224px !important;
      }

      &-7 {
        padding-left: 256px !important;
      }
    }
  }

  &__title {
    @apply text-blue-lighter;
  }

  &__text {
    font-weight: 500;
    @apply text-blue pt-1;
  }
}
</style>
